import { Profile, UserType } from '../profile/profile.model';
import { AzureAdRoles } from './AzureAdRoles';

export interface UserInfo {
    /**
     * Username assigned from UPN or email or preferred_username.
     */
    userName: string;
    /**
     * Properties parsed from `id_token`.
     */
    profile: any;
}

export class VideoPortalUser {
    constructor(private user: UserInfo, private profile: Profile) {
    }

    get costPerCameraMinute(): number {
        return this.profile.costPerCameraMinute;
    }

    get councilName(): string {
        return this.profile.userType === 'Council' ? this.profile.organisation : '';
    }

    get councilSiteNumber(): string {
        return this.profile.councilSiteNumber;
    }

    get email(): string {
        return this.user.profile.upn || this.user.profile.preferred_username || '';
    }

    get hasAgreedToTermsAndConditions(): boolean {
        return this.profile.hasAgreedToTermsAndConditions;
    }

    get isFreeUser(): boolean {
        return this.profile.isFreeUser;
    }

    get name(): string {
        return this.user.profile.name;
    }

    get roles(): string[] {
        const idTokenProfileRoles = (this.user.profile && this.user.profile.roles) || [];
        if (!this.profile) { return idTokenProfileRoles; }
        switch (UserType[this.profile.userType]) {
            case UserType.Council:
                return idTokenProfileRoles.concat(['council']);
            case UserType.JJR:
                return idTokenProfileRoles.concat(['jjr']);
            default:
                return idTokenProfileRoles;
        }
    }

    get hasAdminRole(): boolean {
        return this.roles.some(r => r === AzureAdRoles.AzureActiveDirectoryAdminRole);
    }

    get hasCommercialRole(): boolean {
        return this.hasAdminRole ||
               this.roles.some(r => r === AzureAdRoles.AzureActiveDirectoryViewCommercialRole);
    }

    get hasDomesticRole(): boolean {
        return this.hasAdminRole ||
               this.roles.some(r => r === AzureAdRoles.AzureActiveDirectoryViewDomesticRole);
    }

    // TODO Decide if we actually need this role.
    get hasUserRole(): boolean {
        return this.hasAdminRole ||
               this.roles.some(r => r === AzureAdRoles.AzureActiveDirectoryUserRole);
    }

    get username(): string {
        return this.user.profile.upn || this.user.profile.preferred_username || '';
    }

    isInRole(role: string): boolean {
        return this.roles.indexOf(role) >= 0;
    }
}
